// Exporting a constant with the experiment ID
export const INFORMATION_ARCHITECTURE_EXPERIMENT = 'information_architecture'
